import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFamilyPersonaById } from '../config/familyPersonas';
import ComingSoon from '../shared/ComingSoon';

export default function FamilyPersonaDetail() {
  const { personaId } = useParams();
  const persona = getFamilyPersonaById(personaId);

  return (
    <div className="page">
      <Link to="/family-dashboard/personas" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Family Personas
      </Link>
      {persona ? (
        <ComingSoon
          title={persona.title}
          description="This persona's detail view is planned but not yet available. It will be built out in a future step."
        />
      ) : (
        <ComingSoon title="Unknown persona" description="This family persona does not exist." />
      )}
    </div>
  );
}
